import { render, staticRenderFns } from "./BaseClassificationSelector.vue?vue&type=template&id=20d7bc86"
import script from "./BaseClassificationSelector.vue?vue&type=script&lang=js"
export * from "./BaseClassificationSelector.vue?vue&type=script&lang=js"
import style0 from "./BaseClassificationSelector.vue?vue&type=style&index=0&id=20d7bc86&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports